export default {
	setLocations: (state, locations) =>  state.locations = locations,
	setCheckedLocations: (state, locations) =>  state.checkedLocations = locations,
	addLocation: (state, location) => state.locations.push(location),
	mutateLocation: (state, location) => {
		let index = state.locations.findIndex( place => place.id === location.id );
		state.locations[index] = location;
		state.locations[index].id = state.locations[index].name;
	},
	setFromDialog: (state, value) => state.fromDialog = value,
	setDialog: (state, value) => state.dialog = value,
	setTerminals: (state, terminals) => state.terminals = terminals,
};
